import { useMemo } from 'react';
import { getWebGLConfig } from '../config/webglConfig';

/**
 * Hook to get WebGL configuration for the current page
 * @param {string} pageName - Name of the page (e.g., 'home', 'agents')
 * @returns {object} WebGL configuration object
 */
export const useWebGLConfig = (pageName) => {
  const config = useMemo(() => {
    return getWebGLConfig(pageName);
  }, [pageName]);
  
  return config;
};

export default useWebGLConfig;